/* ============================================================
   DEATH CLUB — theme.js
   Mobile nav, cart drawer (AJAX), qty, countdown
   ============================================================ */
(function(){
  'use strict';

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-nav-toggle]');
    if(t){
      var nav = document.querySelector('[data-main-nav]');
      if(nav) nav.classList.toggle('open');
    }
  });

  /* ---------- Cart drawer open/close ---------- */
  var overlay = document.querySelector('[data-drawer-overlay]');
  var drawer  = document.querySelector('[data-cart-drawer]');
  function openDrawer(){ if(overlay&&drawer){ overlay.classList.add('open'); drawer.classList.add('open'); } }
  function closeDrawer(){ if(overlay&&drawer){ overlay.classList.remove('open'); drawer.classList.remove('open'); } }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); refreshDrawer().then(openDrawer); }
    if(e.target.closest('[data-cart-close]') || e.target.matches('[data-drawer-overlay]')){ closeDrawer(); }
  });

  /* ---------- Update cart count badge ---------- */
  function setCartCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; });
  }

  /* ---------- Fetch & render drawer contents ---------- */
  function money(cents){
    return (window.DC_MONEY_FORMAT || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents/100).toFixed(2));
  }
  function refreshDrawer(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        setCartCount(cart.item_count);
        var box = document.querySelector('[data-drawer-items]');
        var foot = document.querySelector('[data-drawer-subtotal]');
        if(!box) return cart;
        if(cart.item_count === 0){
          box.innerHTML = '<p style="font-family:var(--mono);color:var(--bone-dim);padding:2rem 0;text-align:center">Your cart is empty.</p>';
          if(foot) foot.textContent = money(0);
          return cart;
        }
        var html = '';
        cart.items.forEach(function(it){
          html += '<div class="cart-line" style="grid-template-columns:64px 1fr auto">'
            + '<div class="media"><img src="'+(it.image?it.image.replace(/(\.[^.]+)$/,'_120x$1'):'')+'" alt=""></div>'
            + '<div><div class="ttl">'+it.product_title+'</div>'
            + (it.variant_title && it.variant_title!=='Default Title' ? '<div class="variant">'+it.variant_title+'</div>' : '')
            + '<a href="#" class="remove" data-remove="'+it.key+'">Remove</a></div>'
            + '<div class="lprice">'+money(it.final_line_price)+'</div>'
            + '</div>';
        });
        box.innerHTML = html;
        if(foot) foot.textContent = money(cart.total_price);
        return cart;
      });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action^="/cart/add"], form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if(btn){ btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    var data = new FormData(form);
    fetch('/cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:data})
      .then(function(r){ return r.json(); })
      .then(function(){ return refreshDrawer(); })
      .then(function(){ openDrawer(); })
      .catch(function(){ window.location.href='/cart'; })
      .finally(function(){ if(btn){ btn.disabled=false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  });

  /* ---------- Remove from drawer ---------- */
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-remove]');
    if(!rm) return;
    e.preventDefault();
    var key = rm.getAttribute('data-remove');
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity:0})})
      .then(function(){ return refreshDrawer(); });
  });

  /* ---------- Qty steppers (product + cart page) ---------- */
  document.addEventListener('click', function(e){
    var step = e.target.closest('[data-qty-step]');
    if(!step) return;
    var input = step.parentElement.querySelector('input[type=number]');
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    v += (step.getAttribute('data-qty-step')==='up' ? 1 : -1);
    if(v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  /* ---------- Product thumbs ---------- */
  document.addEventListener('click', function(e){
    var th = e.target.closest('[data-thumb]');
    if(!th) return;
    var main = document.querySelector('[data-main-image]');
    if(main){ main.src = th.getAttribute('data-full'); }
    document.querySelectorAll('[data-thumb]').forEach(function(t){ t.classList.remove('active'); });
    th.classList.add('active');
  });

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(target)){
      // fallback: 7 days from now
      target = Date.now() + 7*24*60*60*1000;
    }
    var out = {
      d: el.querySelector('[data-cd-d]'), h: el.querySelector('[data-cd-h]'),
      m: el.querySelector('[data-cd-m]'), s: el.querySelector('[data-cd-s]')
    };
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var diff = target - Date.now();
      if(diff < 0) diff = 0;
      var d = Math.floor(diff/86400000);
      var h = Math.floor(diff%86400000/3600000);
      var m = Math.floor(diff%3600000/60000);
      var s = Math.floor(diff%60000/1000);
      if(out.d) out.d.textContent = pad(d);
      if(out.h) out.h.textContent = pad(h);
      if(out.m) out.m.textContent = pad(m);
      if(out.s) out.s.textContent = pad(s);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Init cart count on load ---------- */
  if(document.querySelector('[data-cart-count]')){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCartCount(c.item_count); })
      .catch(function(){});
  }
})();
